import { LoadState } from "../../constants/enums";

export interface IDescriptionOfOperation {
  key: string;
  label: string;
  value: string;
}

export interface ICGLSectionOne {
  expiry_date: string;
  policy_number: string;
  effective_date: string;
  insurance_company: string;
}

export interface ICGLSectionTwo {
  occurance: string;
  claim_mode: string;
  cross_liability: string;
  occurance_amount: string;
  claim_mode_amount: string;
  empolyer_liability: string;
  occurance_deductible: string;
  claim_mode_deductible: string;
  waiver_of_subrogation: string;
  cross_liability_amount: string;
  tenants_Legal_Liability: string;
  empolyer_liability_amount: string;
  cross_liability_deductible: string;
  products_completed_oprations: string;
  waiver_of_subrogation_amount: string;
  empolyer_liability_deductible: string;
  pollution_Liability_Extension: string;
  tenants_Legal_Liability_amount: string;
  waiver_of_subrogation_deductible: string;
  empolyer_liability_peronal_injury: string;
  tenants_Legal_Liability_deductible: string;
  products_completed_oprations_amount: string;
  pollution_Liability_Extension_amount: string;
  waiver_of_subrogation_peronal_injury: string;
  products_completed_oprations_deductible: string;
  pollution_Liability_Extension_deductible: string;
}

export interface ICGLSectionThreeItem {
  key: string;
  amount: string;
  coverage: string;
  deductible: string;
  type_of_insurance: string;
  type_of_insurance_check: string;
}

export interface INonOwnedAutomobilesSectionOne {
  expiry_date: string;
  policy_number: string;
  effective_date: string;
  insurance_company: string;
}

export interface INonOwnedAutomobilesSectionTwo {
  non_owned: string;
  non_ownder_amount: string;
  non_owned_deductible: string;
}

export interface IHiredAutomobilesSectionOne {
  expiry_date: string;
  policy_number: string;
  effective_date: string;
  insurance_company: string;
}

export interface IHiredAutomobilesSectionTwo {
  hired_amount: string;
  hired_deductible: string;
  hired_type_of_insurance: string;
}

export interface IAutomobileLiabilitySectionOne {
  expiry_date: string;
  policy_number: string;
  effective_date: string;
  insurance_company: string;
}

export interface IAutomobileLiabilitySectionTwo {
  leased_automobiles: string;
  all_owned_automobiles: string;
  described_automobiles: string;
  property_damage_amount: string;
  leased_automobiles_amount: string;
  property_damage_deductible: string;
  all_owned_automobiles_amount: string;
  described_automobiles_amount: string;
  leased_automobiles_deductible: string;
  all_owned_automobiles_deductible: string;
  described_automobiles_deductible: string;
}

export interface IExcessLiabilitySectionOne {
  expiry_date: string;
  policy_number: string;
  effective_date: string;
  insurance_company: string;
}

export interface IExcessLiabilitySectionTwo {
  extra: string;
  extra_amount: string;
  umbrella_form: string;
  extra_coverage: string;
  aggreate_amount: string;
  extra_deductible: string;
  aggreate_deductible: string;
  umbrella_form_amount: string;
  extra_type_of_insurance: string;
  umbrella_form_deductible: string;
}

export interface IOtherLiabilitySectionOne {
  expiry_date: string;
  policy_number: string;
  effective_date: string;
  insurance_company: string;
}

export interface IOtherLiabilitySectionTwoItem {
  key: string;
  amount: string;
  coverage: string;
  deductible: string;
  type_of_insurance: string;
  type_of_insurance_check: string;
}

export interface ICertificateOfInsurance {
  policy_business_liability_insurance_certificate_id: number;
  customer_id: number | null;
  producer_one_id: number | null;
  producer_one_code: string | null;
  customer_policy_id: number;
  incremental_number: number;
  cgl_policy_number: string;
  is_template: string | null;
  automobile_policy: string;
  umbrella_or_excess_liability_policy: string;
  other_policy: string;
  non_owned_automobiles_policy: string;
  hired_automobiles: string;
  vehicle_unit_number_or_vin: string | null;
  certificate_holder_name: string;
  certificate_holder_address: string;
  certificate_holder_email: string | null;
  certificate_holder_phone: string | null;
  description_of_operations: IDescriptionOfOperation[];
  commercial_general_liability_section_one: ICGLSectionOne;
  commercial_general_liability_section_two: ICGLSectionTwo;
  commercial_general_liability_section_three: ICGLSectionThreeItem[];
  non_owned_automobiles_section_one: INonOwnedAutomobilesSectionOne;
  non_owned_automobiles_section_two: INonOwnedAutomobilesSectionTwo;
  hired_automobiles_section_one: IHiredAutomobilesSectionOne;
  hired_automobiles_section_two: IHiredAutomobilesSectionTwo;
  automobile_liability_section_one: IAutomobileLiabilitySectionOne;
  automobile_liability_section_two: IAutomobileLiabilitySectionTwo;
  excess_liability_section_one: IExcessLiabilitySectionOne;
  excess_liability_section_two: IExcessLiabilitySectionTwo;
  other_liability_section_one: IOtherLiabilitySectionOne;
  other_liability_section_two: IOtherLiabilitySectionTwoItem[];
  cancelation_number_of_days: string;
  brokerage_full_name: string;
  brokerage_mailing_address: string;
  brokerage_customer_code: string;
  additional_name_insured_yes_or_no: string;
  additional_name_insured_name: string;
  additional_name_insured_mailing_address: string;
  certificate_authorization_branch_name: string;
  certificate_authorization_assigned_to: string;
  certificate_authorization_phone_number: string;
  certificate_authorization_fax_number: string | null;
  certificate_authorization_email: string;
  certificate_authorization_date: string;
  certificate_authorization_signature: string | null;
  extra_sheets_attached: string | null;
  status: string;
  created_by_id: number;
  modified_by_id: number | null;
  create_ts: string | null;
  insert_ts: string;
  first_name: string;
  last_name: string;
}

export interface ICertificateOfInsuranceState {
  certificateOfInsuranceList: ICertificateOfInsurance[];
  totalRecords: number;
  loading: LoadState;
}

export const initialCertificateOfInsuranceState: ICertificateOfInsuranceState = {
  certificateOfInsuranceList: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
};
